import dates from "core/dates";
import useNav from "core/hooks/useNav";

import { useMutateBuyGift, useMutateUnlockGift, useMutateUnlock, useQueryRedeem, useQueryUnlock, useQueryGift } from "areas/unlock/data";


export const useContentUnlock = () => {
	const query = useQueryUnlock();
	const nav = useNav();

	const ssk = nav.keys.ssk;
	const cid = nav.keys.cid;
	const data = query.data;

	const getMore = () => nav.preserve("/pay");

	const purchased = data?.purchasedOn;
	const insufficient = data && !purchased && !data?.canUnlock;

	const block = (!ssk && !cid) || insufficient || query.isLoading || !data;

	return { ...query, block, content: data, isPurchased: purchased, insufficient, getMore };
};

export const useUnlock = () => {
	const content = useContentUnlock();
	const mutation = useMutateUnlock();

	const copy = {
		button: content.isPurchased || content.isPassValid ? "Read" : "Unlock",
		title: (() => {
			let text = "Read this article for";
			if (content.isPurchased && !content.isPassValid) text = `You unlocked this article on ${dates.brief(content.isPurchased)}`;
			else if (content.isPass) {
				const duration = Math.round(content.data?.pass.duration / 24);
				const t = duration === 1 ? "Day Pass" : `${duration}-Day Pass`;
				if (content.isPassValid) text = `You have a valid ${t} from ${content.data?.partner.name}`;
				else text = `Unlock this ${t}`;
			}
			return text;
		})(),
		description: (() => {
			if (content.isPass) {
				if (content.isPassValid) return `This pass will expire in ${dates.hours.toDays(dates.hours.difference(content.data?.time.endOn))}`;
				else return `You will have ${dates.hours.toDays(content.data?.pass.duration)} of free reading from ${content.data?.partner.name}`;
			}
		})()
	};

	return { ...content, mutation, copy };
};

export const useBuyGift = () => {
	const content = useQueryGift();
	const mutation = useMutateBuyGift();
	const nav = useNav();

	const copy = {
		title: "Gift this article",
		description: "Share this article with someone special",
		button: "Send gift"
	};

	const isBought = nav.keys.gid || sessionStorage.getItem("gift-id");
	const buyAnother = () => {
		const giftId = sessionStorage.getItem("gift-id");
		if (giftId) sessionStorage.removeItem("gift-id");

		nav.go({ to: "/gift", search: { sub_cid: content.data?.id } });
	};

	const share = async (url) => await navigator.share({ url });

	return { ...content, buyAnother, isBought, mutation, share, copy };
};

export const useRedeemGift = () => {
	const content = useQueryRedeem();
	const mutation = useMutateUnlockGift();

	const copy = {
		title: "Redeem this article",
		description: `${content.data?.gift?.fromUser} has gifted you access to this article`,
		button: "Redeem Gift"
	};

	const block = !content.data || !content.data?.canUnlock;

	return { ...content, block, mutation, copy };
};